import { common } from "./common";
import { auth } from "./auth";
import { menu } from "./menu";
import { chat } from "./chat";
import { note } from "./note";
import { friends } from "./friends";
import { profile } from "./profile";
import { settings } from "./settings";

export const en = {
  ...common,
  ...auth,
  ...menu,
  ...chat,
  ...note,
  ...friends,
  ...profile,
  ...settings,
} as const;
